module.exports = __webpack_public_path__ + "static/media/testimonial-image-banner.24bf4225.png";